import { createModalHook } from '../../hooks/useModal'

export const usePayNowModal = createModalHook()
